import { render, staticRenderFns } from "./SearchHotRecommend.vue?vue&type=template&id=3a301e54&"
import script from "./SearchHotRecommend.vue?vue&type=script&lang=js&"
export * from "./SearchHotRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports